export const USER_AUTH_REQUEST = "USER_AUTH_REQUEST";
export const USER_AUTH_SUCCESS = "USER_AUTH_SUCCESS";
export const USER_AUTH_FAIL = "USER_AUTH_FAIL";
export const USER_AUTH_RESET = "USER_AUTH_RESET";

export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL";
export const USER_LOGIN_RESET = "USER_LOGIN_RESET";

export const USER_REGISTER_REQUEST = "USER_REGISTER_REQUEST";
export const USER_REGISTER_SUCCESS = "USER_REGISTER_SUCCESS";
export const USER_REGISTER_FAIL = "USER_REGISTER_FAIL";
export const USER_REGISTER_RESET = "USER_REGISTER_RESET";

export const USER_EMAIL_VERIFY_REQUEST = "USER_EMAIL_VERIFY_REQUEST";
export const USER_EMAIL_VERIFY_SUCCESS = "USER_EMAIL_VERIFY_SUCCESS";
export const USER_EMAIL_VERIFY_FAIL = "USER_EMAIL_VERIFY_FAIL";
export const USER_EMAIL_VERIFY_RESET = "USER_EMAIL_VERIFY_RESET";

export const USER_EMAIL_RESEND_REQUEST = "USER_EMAIL_RESEND_REQUEST";
export const USER_EMAIL_RESEND_SUCCESS = "USER_EMAIL_RESEND_SUCCESS";
export const USER_EMAIL_RESEND_FAIL = "USER_EMAIL_RESEND_FAIL";
export const USER_EMAIL_RESEND_RESET = "USER_EMAIL_RESEND_RESET";

export const USER_LOGOUT = "USER_LOGOUT";

export const USER_PROFILE_UPDATE_REQUEST = "USER_PROFILE_UPDATE_REQUEST";
export const USER_PROFILE_UPDATE_SUCCESS = "USER_PROFILE_UPDATE_SUCCESS";
export const USER_PROFILE_UPDATE_FAIL = "USER_PROFILE_UPDATE_FAIL";
export const USER_PROFILE_UPDATE_RESET = "USER_PROFILE_UPDATE_RESET";

export const USER_EMAIL_CHANGE_REQUEST_REQUEST =
  "USER_EMAIL_CHANGE_REQUEST_REQUEST";
export const USER_EMAIL_CHANGE_REQUEST_SUCCESS =
  "USER_EMAIL_CHANGE_REQUEST_SUCCESS";
export const USER_EMAIL_CHANGE_REQUEST_FAIL =
  "USER_EMAIL_CHANGE_REQUEST_FAIL";
export const USER_EMAIL_CHANGE_REQUEST_RESET =
  "USER_EMAIL_CHANGE_REQUEST_RESET";

export const USER_EMAIL_CHANGE_VERIFY_REQUEST =
  "USER_EMAIL_CHANGE_VERIFY_REQUEST";
export const USER_EMAIL_CHANGE_VERIFY_SUCCESS =
  "USER_EMAIL_CHANGE_VERIFY_SUCCESS";
export const USER_EMAIL_CHANGE_VERIFY_FAIL =
  "USER_EMAIL_CHANGE_VERIFY_FAIL";
export const USER_EMAIL_CHANGE_VERIFY_RESET =
  "USER_EMAIL_CHANGE_VERIFY_RESET";

export const USER_DEFAULT_SHIPPING_ADDRESS_UPDATE_REQUEST =
  "USER_DEFAULT_SHIPPING_ADDRESS_UPDATE_REQUEST";
export const USER_DEFAULT_SHIPPING_ADDRESS_UPDATE_SUCCESS =
  "USER_DEFAULT_SHIPPING_ADDRESS_UPDATE_SUCCESS";
export const USER_DEFAULT_SHIPPING_ADDRESS_UPDATE_FAIL =
  "USER_DEFAULT_SHIPPING_ADDRESS_UPDATE_FAIL";

export const USER_FORGOT_PASSWORD_REQUEST = "USER_FORGOT_PASSWORD_REQUEST";
export const USER_FORGOT_PASSWORD_SUCCESS = "USER_FORGOT_PASSWORD_SUCCESS";
export const USER_FORGOT_PASSWORD_FAIL = "USER_FORGOT_PASSWORD_FAIL";
export const USER_FORGOT_PASSWORD_RESET = "USER_FORGOT_PASSWORD_RESET";

export const USER_RESET_PASSWORD_REQUEST = "USER_RESET_PASSWORD_REQUEST";
export const USER_RESET_PASSWORD_SUCCESS = "USER_RESET_PASSWORD_SUCCESS";
export const USER_RESET_PASSWORD_FAIL = "USER_RESET_PASSWORD_FAIL";
export const USER_RESET_PASSWORD_RESET = "USER_RESET_PASSWORD_RESET";

export const ADMIN_USER_LIST_REQUEST = "ADMIN_USER_LIST_REQUEST";
export const ADMIN_USER_LIST_SUCCESS = "ADMIN_USER_LIST_SUCCESS";
export const ADMIN_USER_LIST_FAIL = "ADMIN_USER_LIST_FAIL";
export const ADMIN_USER_LIST_RESET = "ADMIN_USER_LIST_RESET";

export const ADMIN_USER_CREATE_REQUEST = "ADMIN_USER_CREATE_REQUEST";
export const ADMIN_USER_CREATE_SUCCESS = "ADMIN_USER_CREATE_SUCCESS";
export const ADMIN_USER_CREATE_FAIL = "ADMIN_USER_CREATE_FAIL";
export const ADMIN_USER_CREATE_RESET = "ADMIN_USER_CREATE_RESET";

export const ADMIN_USER_DETAILS_REQUEST = "ADMIN_USER_DETAILS_REQUEST";
export const ADMIN_USER_DETAILS_SUCCESS = "ADMIN_USER_DETAILS_SUCCESS";
export const ADMIN_USER_DETAILS_FAIL = "ADMIN_USER_DETAILS_FAIL";
export const ADMIN_USER_DETAILS_RESET = "ADMIN_USER_DETAILS_RESET";

export const ADMIN_USER_UPDATE_REQUEST = "ADMIN_USER_UPDATE_REQUEST";
export const ADMIN_USER_UPDATE_SUCCESS = "ADMIN_USER_UPDATE_SUCCESS";
export const ADMIN_USER_UPDATE_FAIL = "ADMIN_USER_UPDATE_FAIL";
export const ADMIN_USER_UPDATE_RESET = "ADMIN_USER_UPDATE_RESET";

export const ADMIN_USER_DELETE_REQUEST = "ADMIN_USER_DELETE_REQUEST";
export const ADMIN_USER_DELETE_SUCCESS = "ADMIN_USER_DELETE_SUCCESS";
export const ADMIN_USER_DELETE_FAIL = "ADMIN_USER_DELETE_FAIL";
export const ADMIN_USER_DELETE_RESET = "ADMIN_USER_DELETE_RESET";
